<template>
  <div>
    <div class="wrapper">
      <HeaderPublic />
      <v-touch :swipe-options="{ direction: 'horizontal' }">
        <transition name="router-animation">
          <router-view />
        </transition>
      </v-touch>
      <footer>
        <hr/>
        <Link :action="goToAssistance" text="Assistance de Cyber Protection" customClass="ml-4" />
      </footer>
    </div>
  </div>
</template>
  
<script>
import { createNamespacedHelpers } from 'vuex';
const { mapState, mapActions } = createNamespacedHelpers('layout');

import HeaderPublic from '@/components/Header/HeaderPublic';
import NavBar from '@/components/NavBar/NavBar';
import BreadcrumbHistory from '@/components/BreadcrumbHistory/BreadcrumbHistory';
import CGU from "@/components/CGU/CGU";
import Link from "@/components/Link/Link";

import './Layout.scss';

export default {
  name: 'Layout',
  components: { HeaderPublic, BreadcrumbHistory, NavBar, CGU, Link },
  data() {
    return {
      isLoadingUpdateContact: false,
      isConditionValidated: true,
      contacts: null,
      company: null,
      cgu: ''
    }
  },
  methods: {
    ...mapActions(['switchSidebar', 'handleSwipe', 'changeSidebarActive', 'toggleSidebar'],
    ),
    handleWindowResize() {
      const width = window.innerWidth;

      if (width <= 768 && this.sidebarStatic) {
        this.toggleSidebar();
        this.changeSidebarActive(null);
      }
    },
    goToAssistance() {
      window.location.href = 'https://assistancepro.orange.fr/internet_livebox/cyber_securite/cyber_protection';
    }
  },
  computed: {
    ...mapState(["sidebarClose", "sidebarStatic"]),
  },
  created() {
    if (localStorage.getItem('token')) {
      if (localStorage.getItem('user.role') === 'COLLABORATOR') {
        this.$router.push('/app/installation');
      } else {
        this.$router.push('/app/dashboard');
      }
    }
    
    const staticSidebar = JSON.parse(localStorage.getItem('sidebarStatic'));

    if (staticSidebar) {
      this.$store.state.layout.sidebarStatic = true;
    } else if (!this.sidebarClose) {
      setTimeout(() => {
        this.switchSidebar(true);
        this.changeSidebarActive(null);
      }, 2500);
    }

    this.handleWindowResize();
    window.addEventListener('resize', this.handleWindowResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleWindowResize);
  }
};
</script>

<style src="./Layout.scss" lang="scss" />
<style scoped lang="scss">
  .wrapper {
    position: relative;
    min-height: 100vh;

    & > div {
      padding-bottom: 6.7rem;
    }

    footer { 
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 5rem;
      margin-bottom: 1.25rem;
      padding: 0 2.5rem;
    }
  }

  hr {
    width: 100%;
    background-color: #ccc!important;
    height: 0px;
  }
</style>
  